import { z } from "zod";

export const bundleServiceSchema = z.object({
  bundleServiceId: z.string(),
  serviceAttributeId: z.string(),
  serviceAttributeValue: z.nullable(z.string()),
});
